import { useTranslation } from 'react-i18next';

import styles from './CardDialog.module.css';
import { useSaveStatus } from './useSaveStatus';

/** "Saving… / Saved / Save failed": an unobtrusive, truthful line for the autosave. */
export function SaveIndicator() {
  const { t } = useTranslation();
  const state = useSaveStatus();
  if (state === 'idle') return <span className={styles.saveSlot} aria-hidden />;
  const text =
    state === 'saving'
      ? t('cardEditor.saving')
      : state === 'saved'
        ? t('cardEditor.saved')
        : t('cardEditor.saveFailed');
  return (
    <span
      className={`${styles.saveState} ${state === 'error' ? styles.saveError : ''}`}
      role={state === 'error' ? 'alert' : undefined}
      aria-live={state === 'error' ? undefined : 'polite'}
      data-state={state}
    >
      {text}
    </span>
  );
}
